const mediaGallery = document.querySelector(".product__media-list");
const thumbnailContainer = document.querySelector(".thumbnail-slider");
const thumbnails = document.querySelectorAll(".thumbnail-item");

if (mediaGallery && window.innerWidth <= 750) {
  let isDown = false;
  let startX;
  let scrollLeft;

  // Funtion to update thumbnails
  function updateActiveThumbnail() {
    const scrollPosition = mediaGallery.scrollLeft;
    const itemWidth = mediaGallery.querySelector(
      ".product__media-item"
    ).offsetWidth;
    const activeIndex = Math.round(scrollPosition / itemWidth);

    thumbnails.forEach((thumb, index) => {
      thumb.classList.remove("is-active");
      if (index === activeIndex) {
        thumb.classList.add("is-active");
        // Centrar el thumbnail activo
        thumb.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    });
  }

  mediaGallery.addEventListener("scroll", updateActiveThumbnail);

  mediaGallery.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - mediaGallery.offsetLeft;
    scrollLeft = mediaGallery.scrollLeft;
    mediaGallery.style.cursor = "grabbing";
  });

  mediaGallery.addEventListener("mouseleave", () => {
    isDown = false;
    mediaGallery.style.cursor = "grab";
  });

  mediaGallery.addEventListener("mouseup", () => {
    isDown = false;
    mediaGallery.style.cursor = "grab";
    updateActiveThumbnail();
  });

  mediaGallery.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - mediaGallery.offsetLeft;
    const walk = (x - startX) * 2;
    mediaGallery.scrollLeft = scrollLeft - walk;
  });

  // Touch events
  mediaGallery.addEventListener("touchstart", (e) => {
    isDown = true;
    startX = e.touches[0].pageX - mediaGallery.offsetLeft;
    scrollLeft = mediaGallery.scrollLeft;
  });

  mediaGallery.addEventListener("touchend", () => {
    isDown = false;
    updateActiveThumbnail();
  });

  mediaGallery.addEventListener("touchmove", (e) => {
    if (!isDown) return;
    const x = e.touches[0].pageX - mediaGallery.offsetLeft;
    const walk = (x - startX) * 2;
    mediaGallery.scrollLeft = scrollLeft - walk;
  });

  updateActiveThumbnail();
}
